/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoleListRequest } from '../models/RoleListRequest';
import type { RoleListResponseApiRespoonse } from '../models/RoleListResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RoleService {

    /**
     * List role
     * @param requestBody
     * @returns RoleListResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminRole(
        requestBody: RoleListRequest,
    ): CancelablePromise<RoleListResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/role',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
